import React from 'react';
import { Button, Flex, Heading, Text } from 'rebass';
import styled from 'styled-components';
import FullLayout2 from '../../../components/FullLayout';
import Header from '../../asyncIntake/Header';
import { isMobile } from 'react-device-detect';
import { withRouter } from 'react-router-dom';
import GutHowItWorks1 from '../../../static/GutHowItWorks1.png';

const SuperContainer = styled(Flex)`
  width: 100vw;
  justify-content: center;
  z-index: 1;
  overflow-y: auto;
  flex: 1;
`;

const Container = styled(Flex)`
  max-width: 400px;
  width: 100%;
  margin: 0 auto;
  margin-top: 80px;
  z-index: 1;
  position: relative;
  overflow-y: none;
  margin-bottom: 36px;
  flex-direction: column;
`;

export const PurchaseTinyHealthKit = withRouter(({ onBuy, onLater }) => {
  return (
    <FullLayout2 pb={5} style={{ zIndex: 11, overflowY: isMobile ? 'hidden' : 'auto', overflowX: 'hidden', maxHeight: '100vh' }}>
      <Header dark={false} mb={3} />
      <SuperContainer>
        <Container>
          <Heading mb={4}>Get Your Tiny Health GI Test Kit</Heading>
          <img src={GutHowItWorks1} alt="" style={{ width: '223px', height: 'auto', objectFit: 'contain', margin: '0 auto' }} />

          <Text style={{ fontSize: '15px' }} mt={2}>
            We partner with Tiny Health to provide advanced microbiome testing.
            <br />
            <br />
            Use your unique Paloma discount at checkout:
          </Text>
          <Text style={{ alignSelf: 'center', padding: '2px 12px', backgroundColor: '#F6A293', fontWeight: 600 }} mt={2}>
            PALOMA
          </Text>

          <Text style={{ fontWeight: 400, fontSize: '12px', opacity: 0.88 }} mt={3}>
            Your results can be uploaded to your provider once available (typically in 3–4 weeks).
          </Text>

          <Button variant={'primary'} mt={4} style={{ alignSelf: 'center', width: 'fit-content' }} onClick={() => onBuy()}>{`Go to Tiny Health →`}</Button>
          <Text
            mt={4}
            textAlign={'center'}
            alignSelf={'center'}
            style={{ color: '#44A5FF', fontSize: '14px', cursor: 'pointer' }}
            onClick={() => {
              onLater();
            }}
          >
            {`I'll do it later >`}
          </Text>
        </Container>
      </SuperContainer>
    </FullLayout2>
  );
});
